<template>
  <section class="text-selector">
    <div class="input-group">
      <input
        ref="text-input"
        type="text"
        class="form-control"
        autocomplete="false"
        spellcheck="false"
        v-bind:disabled="disabled"
        v-bind:value="getTextFromGeneralHands()"
        v-on:keyup.enter="setRangeToMatchText()"
      />
      <div class="input-group-btn">
        <button
          class="btn btn-default"
          data-toggle="modal"
          data-target="#text-selector-help-modal"
          v-bind:disabled="disabled"
        >
          ?
        </button>
        <button
          class="btn btn-default"
          title="Set range according to text"
          v-bind:disabled="disabled"
          v-on:click="setRangeToMatchText()"
        >
          Update
        </button>
      </div>
    </div>
    <help-modal/>
  </section>
</template>

<script>
import HelpModal from '@/components/hand-range/text-selector/help-modal';
import textValidator from '@/services/text/validate';
import getSpecificHandStringsFromText from '@/services/text/get-specific-hand-strings-from-text';

export default {
  name: 'text-selector',
  components: {
    'help-modal': HelpModal,
  },
  props: ['generalHands', 'disabled'],
  methods: {
    getTextFromGeneralHands: function () {
      return this.generalHands.inRangeText;
    },
    setRangeToMatchText: function () {
      let text = this._getCleanedText();
      let checkTextValidityResult = textValidator.checkTextValidity(text);
      let specificHandStringsFromText;

      if (!checkTextValidityResult.valid) {
        alert('Invalid inputs: ' + checkTextValidityResult.invalidParts.join(', '));
        return;
      }

      specificHandStringsFromText = getSpecificHandStringsFromText.run(text);
      this.$emit('setRangeToMatchSpecificHandStrings', specificHandStringsFromText);
    },
    _getCleanedText: function () {
      let text = this.$refs['text-input'].value;

      text = text.toLowerCase();
      text = text.trim();
      text = text.replace(new RegExp(', ', 'g'), ',');

      return text;
    },
  }
};
</script>

<style lang="scss" scoped>
  .input-group {
    width: 100%;

    input[type="text"] {
      width: 100%;
      cursor: auto;
    }
  }

  @media (max-device-width: 768px) {
    .input-group {
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/text-selector/text-selector.vue